import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { selectPostCodeConfig, useSelector } from "@jti/store";
import { AddressFormProvider, useConfig } from "@jti/ui";
import { OrderAttributes } from "../../../../../components/OrderAttributes";
import { useShippingFormContext } from "../../../hooks/useShippingFormContext";
const BillingAddressEditForm = () => {
    const postCodeConfig = useSelector(selectPostCodeConfig);
    const { locationServiceAutocompleteProvider, addressFormVariant } = useConfig();
    const formContext = useShippingFormContext();
    const { errors } = formContext.formState;
    const billintAddress = formContext.watch("billingAddress");
    useEffect(() => { }, [errors?.root, billintAddress.postcode]);
    useEffect(function clearServerErrors() {
        if (errors.root?.billingAddress?.type === "server") {
            formContext.clearErrors("root.billingAddress");
        }
    }, [formContext.clearErrors, billintAddress?.postcode, errors]);
    return (_jsxs(_Fragment, { children: [_jsx(OrderAttributes, { target: "billingaddress_before" }), _jsx(AddressFormProvider, { locationServiceAutocompleteProvider: locationServiceAutocompleteProvider, formType: addressFormVariant, fieldName: (name) => `billingAddress.${name}`, postCodeConfig: postCodeConfig }), _jsx(OrderAttributes, { target: "billingaddress_after" })] }));
};
export default BillingAddressEditForm;
//# sourceMappingURL=BillingAddressEditForm.js.map